export function Init() {
  if (window.grecaptcha) return Promise.resolve(grecaptcha)
  return new Promise((resolve, reject) =>{
    window.__cvt_recaptcha_loaded = function () {
      return resolve(window.grecaptcha)
    }
    const script = document.createElement( 'script' );
    script.id = 'convrrt-recaptcha'
    script.src = `https://www.google.com/recaptcha/api.js?onload=__cvt_recaptcha_loaded&render=explicit`
    script.type = 'text/javascript'
    script.async = true
    script.defer = true
    script.onerror = reject
    document.body.appendChild( script )
  })
}
